import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DoneBanner from '../done_banner';
import AutocompleteBootstrap5 from '../../../../autocompletes/autocomplete_bootstrap_5';
import { formatElement, getBannerText } from './helper_methods';
import { excludeSelectedItems } from '../../../../../../utilities/utilities';
import { updateField } from '../../../services';
import {
  autocompletePlacesPath,
  autocompleteLanguagesPath
} from '../../../../../../utilities/api_relative_paths';

const CitizenshipsLanguagesBanners = ({ type, userID, values, removeBanner }) => {
  const [step, setStep] = useState('edit');
  const [elements, setElements] = useState(values);

  useEffect(() => {
    if (step === 'done') {
      setTimeout(removeBanner, 7000);
    }
  }, [step]);

  /**
   * Remove the element (citizenship or language) clicked from the array of elements.
   *
   * @param {number} elementIndex - Index of the element selected to remove
   * @returns {undefined}
   */
  const handleRemoveElement = (elementIndex) => {
    const result = elements.filter((element, index) => {
      return index !== elementIndex;
    });
    setElements(result);
  };

  const displayElements = () => {
    if (!elements.length) return '';
    return elements.map((element, index) => {
      return (
        <span key={element.id}>
          <span>
            <button
              className='btn btn-removable'
              type='button'
              onClick={() => handleRemoveElement(index)}
            >
              {element.name || element.text}
            </button>
          </span>
        </span>
      );
    });
  };

  /**
   * Calls the helper method formatElement to format the selected element
   * to be saved as is expected to be received in the BE.
   *
   * @param {object} selected - element selected (citizenship or language)
   * @returns {undefined}
   */
  const onSelect = (selected) => {
    if (selected) {
      setElements([...elements, formatElement(selected, type)]);
    }
  };

  const displayAutocomplete = () => {
    if (type === 'citizenships') {
      return (
        <AutocompleteBootstrap5
          inputProps={{ className: 'form-control' }}
          placeholder='Select location'
          id='placesAutocomplete'
          apiPath={autocompletePlacesPath}
          onSelect={onSelect}
          selected={[]}
          filter={{ types: ['Country'] }}
          filterBy={(option) => excludeSelectedItems(option, elements)}
          disabled={elements.length >= 3}
        />
      );
    }
    return (
      <AutocompleteBootstrap5
        inputProps={{ className: 'form-control' }}
        placeholder='Select language'
        id='LanguagesAutocomplete'
        apiPath={autocompleteLanguagesPath}
        onSelect={onSelect}
        selected={[]}
        filterBy={(option) => excludeSelectedItems(option, elements)}
        disabled={elements.length >= 5}
      />
    );
  };

  const handleUpdate = () => {
    const data = {
      consultant: {
        [type]: elements,
      },
    };
    updateField(type, data, userID);
    setStep('done');
  };

  if (step === 'done') return <DoneBanner action='updating' />;
  return (
    <div className='data-input' data-testid={`edit-${type}`}>
      <div className='form-group mb-3'>
        <label className='mb-35 text-center'>{getBannerText(type)}</label>
        <span className='filter-buttons'>{displayElements()}</span>
        {displayAutocomplete()}
      </div>
      <div className='text-center'>
        <button className='btn btn-outline-primary' type='button' onClick={handleUpdate}>
          Update
        </button>
      </div>
    </div>
  );
};

CitizenshipsLanguagesBanners.propTypes = {
  type: PropTypes.string.isRequired,
  userID: PropTypes.number.isRequired,
  values: PropTypes.array.isRequired,
  removeBanner: PropTypes.func.isRequired,
};

export default CitizenshipsLanguagesBanners;
